<template>
  <div>
    <!-- <code>
      <pre>
        {{ aupair }}
      </pre>
    </code> -->
    <ChiCard className="p-0 relative">
      <Ribbon v-if="aupair.inCountry" :ribbonLabel="'10% OFF'" />
      <div
        class="px-12 py-5 flex flex-col md:flex-row items-center justify-center text-center md:text-left border-b border-purple-ap-t03"
      >
        <div class="w-full md:w-2/5">
          <AuPairName
            :name="aupair.firstName"
            :auPairPromoProfileId="aupair.auPairPromoProfileId"
          />
          <ChildCareHours :aupair="aupair" />
        </div>
        <div class="w-full md:w-2/5 my-5 md:my-0 text-center">
          <Nationality :birthCountry="aupair.birthCountry" />
          <Age :age="aupair.birthDate" />
        </div>
        <div class="w-full md:w-2/5">
          <div
            class="flex flex-row md:flex-col justify-center md:justify-end items-center"
          >
            <InfantCareQualified
              :infantCareQualified="aupair.infantCareQualified"
            />
            <Driver :experiencedDriver="aupair.experiencedDriver" />
            <Swimmer :swimmer="aupair.swimmer" />
          </div>
        </div>
      </div>

      <div
        class="py-10 px-12 flex flex-col md:flex-row items-center justify-between text-center md:text-left"
      >
        <div class="relative flex flex-col justify-center">
          <router-link
            :to="{
              name: 'Profile',
              params: { id: aupair.auPairPromoProfileId },
            }"
          >
            <Photo :src="aupair.profilePhoto" :alt="aupair.firstName" />
          </router-link>

          <CompatibilityScore
            :score="aupair.score"
            :characteristics="aupair.auPairCharacteristicsId"
          />
        </div>

        <div class="md:w-2/3 pt-5 md:pl-5 md:pt-0">
          <ProfileSummary :profileSummary="aupair.profileSummary" />
        </div>
      </div>

      <div
        class="flex flex-col lg:flex-row justify-between items-center w-full bg-purple-ap-100 p-5"
      >
        <FirstAvailableDate
          class="text-xl text-white font-light"
          :date="aupair.firstAvailableDate"
        />

        <router-link
          tag="button"
          :to="{
            name: 'Profile',
            params: { id: aupair.auPairPromoProfileId },
          }"
          class="mt-3 md:mt-0 btn btn-white"
          >View Profile
        </router-link>
      </div>
    </ChiCard>
  </div>
</template>

<script>
import ChiCard from "@/components/UI/ChiCard.vue";
import AuPairName from "@/components/AuPairs/AuPairCardItems/AuPairName.vue";
import ChildCareHours from "@/components/AuPairs/AuPairCardItems/ChildCareHours.vue";
import Nationality from "@/components/AuPairs/AuPairCardItems/Nationality.vue";
import Age from "@/components/AuPairs/AuPairCardItems/Age.vue";
import InfantCareQualified from "@/components/AuPairs/AuPairCardItems/InfantCareQualified.vue";
import Driver from "@/components/AuPairs/AuPairCardItems/Driver.vue";
import Swimmer from "@/components/AuPairs/AuPairCardItems/Swimmer.vue";
import Photo from "@/components/AuPairs/AuPairCardItems/Photo.vue";
import ProfileSummary from "@/components/AuPairs/AuPairCardItems/ProfileSummary.vue";
import FirstAvailableDate from "@/components/AuPairs/AuPairCardItems/FirstAvailableDate.vue";
import CompatibilityScore from "@/components/AuPairs/AuPairCardItems/CompatibilityScore.vue";
import Ribbon from "@/components/UI/Ribbon.vue";

export default {
  name: "AuPairCard",
  props: {
    aupair: Object,
  },
  components: {
    ChiCard,
    AuPairName,
    ChildCareHours,
    Nationality,
    Age,
    InfantCareQualified,
    Driver,
    Swimmer,
    Photo,
    ProfileSummary,
    FirstAvailableDate,
    CompatibilityScore,
    Ribbon,
  },
};
</script>
